export default {
  resource: "admin.adminPlugins.show",

  path: "/plugins",

  map() {
    this.route("discourse-ai-agents", { path: "ai-agents" }, function () {
      this.route("new");
      this.route("edit", { path: "/:id/edit" });
    });
    this.route("discourse-ai-agents-legacy", { path: "ai-personas/*path" });

    this.route("discourse-ai-llms", { path: "ai-llms" }, function () {
      this.route("new");
      this.route("edit", { path: "/:id/edit" });
    });

    this.route("discourse-ai-secrets", { path: "ai-secrets" }, function () {
      this.route("new");
      this.route("edit", { path: "/:id/edit" });
    });

    this.route("discourse-ai-tools", { path: "ai-tools" }, function () {
      this.route("new");
      this.route("edit", { path: "/:id/edit" });
      this.route("mcp-server-new", { path: "/mcp-servers/new" });
      this.route("mcp-server-edit", { path: "/mcp-servers/:id/edit" });
    });
    this.route("discourse-ai-spam", { path: "ai-spam" });
    this.route("discourse-ai-translations", { path: "ai-translations" });
    this.route("discourse-ai-usage", { path: "ai-usage" });

    this.route(
      "discourse-ai-embeddings",
      { path: "ai-embeddings" },
      function () {
        this.route("new");
        this.route("edit", { path: "/:id/edit" });
      }
    );

    this.route("discourse-ai-features", { path: "ai-features" }, function () {
      this.route("edit", { path: "/:id/edit" });
    });
  },
};
